// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2Yv9-","log":"ModalInventoryLogs_log__27eDz","date":"ModalInventoryLogs_date__x_OV4","userName":"ModalInventoryLogs_userName__9x-Np"};